import produce from "immer";

import { noteActionNames, NoteActionTypes } from "./noteActionTypes";
import { NoteState } from "./noteState";

export const noteReducer = (
    state: NoteState,
    action: NoteActionTypes
): NoteState =>
    produce(state, draft => {
        draft.error = undefined;
        draft.hasError = false;
        switch (action.type) {
            case noteActionNames.LOAD_NOTES: {
                draft.currentUserId = action.payload.userId;
                draft.currentJobId = action.payload.jobId;
                break;
            }
            case noteActionNames.LOAD_NOTES_SUCCESS: {
                draft.notes = action.payload.notes;
                break;
            }
            case noteActionNames.LOAD_NOTES_FAILURE: {
                draft.error = action.payload.error;
                draft.hasError = true;
                break;
            }
            case noteActionNames.SET_CURRENT_NOTE_CONTEXT: {
                draft.currentContext = action.payload.noteContext;
                break;
            }
            case noteActionNames.ADD_NOTE: {
                const newNotes = [...state.notes];
                newNotes.push(action.payload.note);
                draft.notes = newNotes;
                break;
            }
            case noteActionNames.SET_NOTE_IS_DIRTY: {
                draft.isDirty = action.payload.isDirty;
                break;
            }
        }
    });
